import { Flag, Gauge, RotateCcw, Target } from "lucide-react";
import { Card } from "../../../components/ui/Card";
import { SectionHeader } from "../../../components/ui/SectionHeader";
import { useAthleteProfile } from "../../athlete-profile/AthleteProfileProvider";
import { formatDailyFluids, formatFluidsMlPerHour } from "../../athlete-profile/formatters";

export function NutritionIntelligence() {
  const { athleteProfile } = useAthleteProfile();
  const profileNutrition = athleteProfile.nutrition;
  const dailyTargets = [
    `${profileNutrition.dailyCalories} kcal`,
    `${profileNutrition.defaultCarbohydrateTargetGrams}g carbohydrate`,
    `${profileNutrition.proteinTargetGrams}g protein`,
    `${profileNutrition.defaultFatTargetGrams}g fat`,
    `${profileNutrition.dailySodiumTargetMg} mg sodium`,
    formatDailyFluids(profileNutrition.dailyFluidTargetMl, athleteProfile.personal.preferredUnits)
  ];
  const rideFuelTargets = [
    `During: ${profileNutrition.preferredRideCarbsPerHour}g carbs/hr`,
    `Sodium: ${profileNutrition.preferredSodiumMgPerHour} mg/hr`,
    `Fluids: ${formatFluidsMlPerHour(profileNutrition.preferredFluidsMlPerHour, athleteProfile.personal.preferredUnits)}`
  ];
  const recoveryFuelTargets = [
    `${Math.round(profileNutrition.proteinTargetGrams * 0.2)}g protein + ${Math.round(profileNutrition.defaultCarbohydrateTargetGrams * 0.25)}g carbs after training`,
    formatDailyFluids(profileNutrition.dailyFluidTargetMl, athleteProfile.personal.preferredUnits),
    "Evening meal centered on mixed carbohydrates and lean protein"
  ];
  const targetSummary = [
    `Calories target: ${profileNutrition.dailyCalories} kcal`,
    `Sodium target: ${profileNutrition.dailySodiumTargetMg} mg`,
    `Fluid target: ${formatDailyFluids(profileNutrition.dailyFluidTargetMl, athleteProfile.personal.preferredUnits)}`
  ];

  return (
    <Card>
      <SectionHeader
        eyebrow="NUTRITION INTELLIGENCE"
        title="Fueling plan is session-matched"
        subtitle="Decision support for daily intake and session execution"
      />
      <div className="nutrition-groups">
        <article className="nutrition-group">
          <h3><Target size={16} /> Daily Targets</h3>
          <ul className="command-list compact-list">
            {dailyTargets.map(item => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </article>
        <article className="nutrition-group">
          <h3><Gauge size={16} /> Ride Fuel</h3>
          <ul className="command-list compact-list">
            {rideFuelTargets.map(item => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </article>
        <article className="nutrition-group">
          <h3><RotateCcw size={16} /> Recovery Fuel</h3>
          <ul className="command-list compact-list">
            {recoveryFuelTargets.map(item => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </article>
        <article className="nutrition-group">
          <h3><Flag size={16} /> Remaining Nutrition</h3>
          <ul className="command-list compact-list">
            {targetSummary.map(item => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </article>
      </div>
    </Card>
  );
}
